module.exports = __webpack_public_path__ + "img/ee_navigator_logo.eba43823.png";